import React, { type FunctionComponent } from 'react'
import { colors, NewSelect } from '@retailer-platform/shared-components'
import {
  FeatureConfigKey,
  type QualityAuditWorkflowFeatureConfig,
} from '../../types/qualityAuditWorkflows.types.ts'
import { QualityAuditWorkflowConfigPresetOption } from './components/QualityAuditWorkflowConfigPresetOption.tsx'
import { QualityAuditWorkflowConfigPreset } from './util/qualityAuditWorkflowConfigPresetDetails.tsx'

interface Props {
  onChange: (features: QualityAuditWorkflowFeatureConfig) => void
}

export const QualityAuditWorkflowConfigPresets: FunctionComponent<
  React.PropsWithChildren<Props>
> = ({ onChange }) => (
  <NewSelect
    onChange={value => {
      if (value === QualityAuditWorkflowConfigPreset.CAMP_WORKFLOW) {
        onChange({
          [FeatureConfigKey.EnableAccumulatingTasks]: JSON.stringify(true),
          [FeatureConfigKey.MaxAccumulatingDays]: JSON.stringify(1),
          [FeatureConfigKey.MinTasksPerBatch]: JSON.stringify(1),
        })
      } else if (value === QualityAuditWorkflowConfigPreset.BATCH_ONLY_ALLOWS_APPROVALS) {
        onChange({
          [FeatureConfigKey.SetDefaultTaskState]: 'rejected',
          [FeatureConfigKey.ShowApproved]: JSON.stringify(true),
          [FeatureConfigKey.ShowRejected]: JSON.stringify(false),
        })
      } else if (value === QualityAuditWorkflowConfigPreset.BATCH_ONLY_ALLOWS_REJECTIONS) {
        onChange({
          [FeatureConfigKey.SetDefaultTaskState]: 'approved',
          [FeatureConfigKey.ShowApproved]: JSON.stringify(false),
          [FeatureConfigKey.ShowRejected]: JSON.stringify(true),
        })
      }
    }}
    hideSelectedOptions={true}
    isMulti={false}
    styles={{
      menuPortal: base => ({
        ...base,
        zIndex: 9000,
        whiteSpace: 'nowrap',
        width: 'max-content',
      }),
      menu: base => ({
        ...base,
        width: 'max-content',
        zIndex: 9000,
        whiteSpace: 'nowrap',
      }),
      container: base => ({
        ...base,
        marginTop: 'auto',
        width: 'auto',
      }),
      control: base => ({
        ...base,
        width: 'max-content',
      }),
      singleValue: base => ({
        ...base,
        color: colors.SUCCESS.DARK,
      }),
    }}
    menuPortalTarget={document.body}
    compact={true}
    options={[
      {
        label: 'Presets',
        value: 'presets',
      },
      {
        label: QualityAuditWorkflowConfigPreset.CAMP_WORKFLOW,
        value: QualityAuditWorkflowConfigPreset.CAMP_WORKFLOW,
      },
      {
        label: QualityAuditWorkflowConfigPreset.BATCH_ONLY_ALLOWS_REJECTIONS,
        value: QualityAuditWorkflowConfigPreset.BATCH_ONLY_ALLOWS_REJECTIONS,
      },
      {
        label: QualityAuditWorkflowConfigPreset.BATCH_ONLY_ALLOWS_APPROVALS,
        value: QualityAuditWorkflowConfigPreset.BATCH_ONLY_ALLOWS_APPROVALS,
      },
    ]}
    components={{ Option: QualityAuditWorkflowConfigPresetOption }}
    value={'presets'}
    isSearchable={true}
  />
)
